module.exports = __webpack_public_path__ + "static/media/ThumbsUp_Icon.94653006.png";